import { z } from 'zod';

// The referral pause policy.
// - canPause: whether the pause action is available for the organization's
//   referrals at all (admin referral page + pause API). L&G CI: false.
// - cancelPausedAfterDays: how long a referral may stay paused, in DAYS,
//   before the scheduled Cancel*PausedReferral jobs cancel it (from pausedAt).
//   `null` disables the job. L&G / Healix / Aviva: 42 (6 weeks).
// The two fields share ONE group deliberately: a paused-cancellation window is
// meaningless without pausing, and only fields in the same doc inherit
// atomically. Split across groups they could resolve from different ancestors
// (child overrides canPause, parent still supplies the window) into an
// incoherent combination no per-doc schema could reject — kept coherent here
// by the cross-field rule below.
// A present doc fully defines the group: all fields are required
// (the window is nullable).
export const ReferralPausingSettingsSchema = z
  .strictObject({
    canPause: z.boolean(),
    cancelPausedAfterDays: z.number().int().positive().nullable(),
  })
  .check((ctx) => {
    const { canPause, cancelPausedAfterDays } = ctx.value;

    if (canPause !== false || cancelPausedAfterDays === null) {
      return;
    }

    ctx.issues.push({
      code: 'custom',
      input: ctx.value,
      path: ['cancelPausedAfterDays'],
      message: 'cancelPausedAfterDays must be empty when pausing is disabled',
    });
  });

export type ReferralPausingSettings = z.infer<
  typeof ReferralPausingSettingsSchema
>;
